/*German (Germany) locale*/
const locale = {
	or: "oder",
	and: "und",
	delete_rule: "Regel löschen",
	add_rule: "Regel hinzufügen",
	add_group: "Gruppe hinzufügen",
	less: "weniger",
	less_or_equal: "weniger oder gleich",
	greater: "mehr",
	greater_or_equal: "größer oder gleich",
	between: "zwischen",
	not_between: "nicht zwischen",
	begins_with: "beginnt mit",
	not_begins_with: "nicht beginnt mit",
	contains: "enthält",
	not_contains: "nicht enthält",
	ends_with: "endet mit",
	not_ends_with: "nicht endet mit",
	is_empty: "ist leer",
	is_not_empty: "es ist nicht leer",
	equal: "gleich",
	not_equal: "ungleich",
	is_null: "ist null",
	is_not_null: "es ist nicht null",
	default_option: "---",
	cancel: "Stornieren",
	filter: "Filter",
	sort: "Sortieren"
};

export default locale;